import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const OrganizationListNotice = styled.div`
  align-items: center;
  color: var(--color-accent-secondary-default);
  display: flex;
  gap: 4px;
`;

const OrganizationList = styled.div`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  direction: rtl;
  margin-top: 16px;
  max-height: 336px;
  overflow-y: auto;
`;

const OrganizationListItem = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  direction: ltr;
  display: flex;
  font-size: 16px;
  height: 48px;
  justify-content: space-between;
  padding: 12px;
  text-align: left;
  transition: 0.25s background-color;
  width: 100%;

  &:hover {
    background-color: var(--color-gray-25);
  }

  & + & {
    border-top: 0.2px solid var(--color-accent-secondary-weaker);
  }
`;

const OrganizationListItemTitle = styled.span``;

const OrganizationNoResult = styled.div`
  align-items: center;
  color: var(--color-neutral-400);
  direction: ltr;
  display: flex;
  height: 48px;
  padding: 0 32px;
`;

const SelectOrganizationTemplate = styled.div`
  background-color: var(--color-white-main);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  padding: 40px;
  width: 458px;

  ${DEVICE.mobile.max} {
    padding: 24px;
    width: 100%;
  }
`;
export {
  OrganizationList,
  OrganizationListItem,
  OrganizationListItemTitle,
  OrganizationListNotice,
  OrganizationNoResult,
  SelectOrganizationTemplate
};
